import { __API } from './api';
import { __catIconData } from './categoryIcon';
import { __TicketCategoryData } from './mrCity';
import { __PATH } from './path';

export const API = __API;
export const PATH = __PATH;
export const TicketCategoryData = __TicketCategoryData;
export const catIconData = __catIconData;
